export default __webpack_public_path__ + "static/media/yp_logo.f09370c1.svg";